<template>
  <v-text-field
    v-model="response"
    v-bind="$attrs"
    :autofocus="autofocus"
    :disabled="disabled"
    :readonly="readonly"
    :error-messages="computedErrors"
    :error="error"
    :rules="rules"
    :data-cy="dataCy"
    class="sel_phone"
    inputmode="tel"
    pattern="\d*"
    maxlength="14"
    autocomplete="nope"
    outlined
    flat
    solo
    v-on="$listeners"
    @blur="$emit('blur', $event)"
    @change="validatePhoneNumber"
    @focus="localErrors = []; $emit('focus', $event)"
    @keydown.native="preventChar"
    @keyup.native="disableCopy"
    @paste.native="parsePaste"
  />
</template>

<script>
export default {
  name: 'SnPhone',

  props: {
    autofocus: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    errorMessages: {
      type: [String, Array],
      default: '',
      required: false
    },
    rules: {
      type: Array,
      default: () => [],
      required: false
    },
    value: {
      type: String,
      default: '',
      required: false
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    dataCy: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      response: '',
      localErrors: [],
      allowedKeys: ['Backspace', 'Tab', 'Control', 'Meta', 'ArrowLeft', 'ArrowRight', 'Left', 'Right'],
      copyEnabled: false
    }
  },
  computed: {
    computedErrors () {
      return this.localErrors.concat(this.errorMessages)
    }
  },
  watch: {
    value (newVal) {
      this.response = newVal
    },
    response (newVal) {
      let num = newVal !== null ? newVal.replace(/\D/g, '') : ''
      if (num.length > 6) {
        num = `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`
      } else if (num.length > 3) {
        num = `(${num.slice(0, 3)}) ${num.slice(3)}`
      }
      this.response = num
      this.$emit('input', this.response)
    }
  },
  created () {
    this.response = this.value
  },
  methods: {
    preventChar (event) {
      if (event.key === 'Control' || event.key === 'Meta') {
        this.copyEnabled = true
      }

      if (!'0123456789'.includes(event.key) &&
          !this.allowedKeys.includes(event.key) &&
          !('acvx'.includes(event.key) && this.copyEnabled)) {
        event.preventDefault()
      }
    },
    disableCopy (event) {
      if (event.key === 'Control' || event.key === 'Meta') {
        this.copyEnabled = false
      }
    },
    validatePhoneNumber () {
      if (this.response.length && this.response.length < 14) {
        this.localErrors = ['Please enter a valid 10-digit phone number']
      } else {
        this.localErrors = []
      }
    },
    clearErrors () {
      if (this.response.length === 14) {
        this.localErrors = []
      }
    },
    parsePaste (event) {
      const clipboardData = event.clipboardData || window.clipboardData
      const pastedData = clipboardData.getData('Text').replace(/[^0-9.]/g, '').substring(0, 10)
      event.preventDefault()
      const tempNum = this.response + pastedData
      this.response = tempNum.substr(0, 14)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.sn-text {
  font-family: $font-family-primary !important;
  .v-input--is-disabled {
    ::v-deep .v-input__slot {
      background-color: $sn-gray-01;
      border: 1px solid $sn-gray-04 !important;
      .v-text-field__slot {
        input {
          color: $sn-primary-01 !important;
        }
      }
    }
  }
  ::v-deep {
    font-family: $font-family-primary !important;
    .v-input__slot {
      border: 1px solid $sn-gray-04;
      box-sizing: border-box;
      border-radius: 2px;
      min-height: 46px !important;

      & fieldset {
        border: none;
      }

      &:focus-within {
        border: 1px solid $sn-primary !important;
      }

      &:hover {
        border: 1px solid $sn-primary !important;
      }
    }
    .v-text-field__slot {
      min-height: 46px;
    }
  }
  .error--text {
    ::v-deep .v-input__slot {
      border-color: #FF5252;

      &:hover {
        border-color: #FF5252 !important;
      }
    }
  }
  ::v-deep .v-text-field__details {
    padding-left: 0 !important;
  }

  ::v-deep .v-text-field__slot {
    input {
      caret-color: $sn-primary;
    }
  }
  ::v-deep .v-messages {
    color: $sn-primary-01;

    .v-messages__message {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 20px;
    }

    &.error--text {
      font-size: 15px;
      display: inline-flex;
      align-items: center;
      visibility: visible;

      &:before {
        content: '\26A0';
        margin-right: 5px;
        font-size: 15px;
        margin-bottom: 22px;
      }

      .v-messages__wrapper {
        display: inline-flex;
        padding-bottom: 2px;
      }
    }
  }
}
</style>
